// Session components
const Redirect = () => import( "@/pages/Session/Redirect" );
const CalendarAuthorizationCallback = () => import( "@/components/Session/CalendarAuthorizationCallback" );
const LoadingPage = () => import( "@/pages/LoadingPage" );
const NotFound = () => import( "@/pages/NotFound" );

const newTeamPath = {
	"team-members": "settings",
	"team-work-style": "workstyle",
	"team-health": "health",
	"team-goals": "goals",
	"team-commitments": "commitments",
};

export default [
	//
	// Root
	//
	{
		path: "/",
		name: "home",
		redirect: "loading",
	},

	{
		path: "/calauth",
		name: "calauth",
		component: CalendarAuthorizationCallback,
	},

	{
		path: "/loading",
		name: "loading",
		component: LoadingPage,
		meta: {
			requiresAuth: true,
		},
	},

	//
	// Session
	//
	{
		name: "signup",
		path: "/session/sign-up",
		component: Redirect,
		props: () => ( {
			redirectUrl: "/t2/signup",
		} ),
	},

	{
		path: "/session/login",
		name: "login",
		component: Redirect,
		props: () => ( {
			redirectUrl: "/t2/signin",
		} ),
	},

	{
		path: "/schedule/:meetingId",
		name: "scheduled-meeting",
		beforeEnter() {
			window.location.assign( "/t2/one-on-ones" );
		},
	},

	{
		path: "/schedule",
		name: "schedule",
		alias: [ "/", "/dashboard", ],
		beforeEnter() {
			window.location.assign( "/t2/one-on-ones" );
		},
	},

	{
		path: "/mc/:meetingCode",
		name: "meeting-center",
		beforeEnter() {
			window.location.assign( "/t2/one-on-ones" );
		},
	},

	{
		path: "/mc/outcomes/:meetingId",
		name: "outcomes",
		beforeEnter() {
			window.location.assign( "/t2/action-items" );
		},
	},

	{
		path: "/goals",
		name: "goals",
		beforeEnter() {
			window.location.assign( "/t2/goals" );
		},
	},

	{
		path: "/teams",
		name: "teams",
		beforeEnter() {
			window.location.assign( "/t2/teams" );
		},
	},

	{
		path: "/teams/:teamId",
		name: "team",
		children: [
			{
				path: "team-members",
				name: "team-members",
			},
			{
				path: "team-work-style",
				name: "team-work-style",
			},
			{
				path: "team-health",
				name: "team-health",
			},
			{
				path: "team-goals",
				name: "team-goals",
			},
			{
				path: "team-commitments",
				name: "team-commitments",
			},
		],
		beforeEnter( to ) {
			const splitPath = to.fullPath.split( "/" );
			const subPath = splitPath[ splitPath.length - 1 ];
			const newSubPath = newTeamPath[ subPath ] || "meetings";
			const url = `/t2/team/${ to.params.teamId }/${ newSubPath }`;
			window.location.assign( url );
		},
	},

	{
		path: "/one-on-one/:teamId",
		name: "one-on-one",
		beforeEnter( to ) {
			const url = `/t2/one-on-one/${ to.params.teamId }/`;
			window.location.assign( url );
		},
	},

	{
		path: "/commitments",
		name: "commitments",
		beforeEnter() {
			window.location.assign( "/t2/action-items" );
		},
	},

	{
		path: "/me",
		name: "profile",
		beforeEnter() {
			window.location.assign( "/t2/me/profile" );
		},
	},

	{
		path: "/onboarding",
		name: "onboarding",
		redirect: { name: "schedule", },
	},

	{
		path: "/settings",
		name: "settings",
		beforeEnter() {
			window.location.assign( "/t2/me/settings" );
		},
	},

	//
	// 404
	//
	{
		path: "*",
		component: NotFound,
		meta: {
			title: "Page Not Found",
			breadcrumb: "Page Not Found",
		},
	},

	//
	// External Links
	//
	{
		path: "https://www.teaming.com",
		name: "teaming",
		beforeEnter() {
			// Put the full page url including the protocol http(s) below
			window.location = "https://www.teaming.com";
		},
	},
];



// WEBPACK FOOTER //
// ./src/router/routes.js